// @flow
import { applyMiddleware, createStore, compose, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { user } from '@finect/front-core/User';
import { authorizations } from '@finect/front-core/Authorizations';
import type { StoreType } from '../types/store';
import { omninav } from './omninav/reducers';
import { terms } from './terms/reducers';
import { error } from './error/reducers';

const reducer = combineReducers({
  user,
  authorizations,
  omninav,
  terms,
  error
});

/* eslint-disable */
export function configureStore(initialState: Object = {}) {
  const store = createStore(
    reducer,
    initialState,
    compose(
      applyMiddleware(thunkMiddleware),
      typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : f => f
    )
  );

  return store;
}
/* eslint-enable */

export const mapStateToProps = (state: StoreType) => state;
